<div class="viewer-header">
  <h2>{{ data.tituloDoArquivo }}</h2>
  <div>
    <button mat-stroked-button color="warn" *ngIf="canReportar()"
      (click)="reportarIdentificacao()">
      <mat-icon>report_problem</mat-icon>
      Reportar identificação do candidato
    </button>
    <button mat-icon-button (click)="toggleFullscreen()" [matTooltip]="isFullscreen ? 'Sair da tela cheia' : 'Visualizar em tela cheia'">
      <mat-icon>{{ isFullscreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
    </button>
    <button mat-icon-button mat-dialog-close matTooltip="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<inscricoes-input-nota-avaliacao *ngIf="data.onNotaSave"
  [notaInicial]="notaAtual"
  [disabled]="isEnvelopeEnviado()"
  [peso]="peso"
  (confirmarNota)="onNotaConfirmation($event)" />
<iframe title="Prova Escrita" width="100%" class="viewer-iframe"></iframe>

<div class="viewer-reporte-actions" *ngIf="data.temReportePendente">
  <div class="reporte-info" *ngIf="!mostrarConfirmacaoDecisao">
    <mat-icon color="warn">announcement</mat-icon>
    <span>Esta prova possui suspeita de identificação do candidato.</span>
  </div>
  <div class="reporte-decisao-btns" *ngIf="!mostrarConfirmacaoDecisao">
    <button mat-stroked-button (click)="abrirHistoricoReporte()">
      <mat-icon>history</mat-icon> Histórico
    </button>
    <button mat-stroked-button class="btn-liberar" (click)="iniciarDecisao('liberar')">
      <mat-icon>check_circle</mat-icon> Liberar
    </button>
    <button mat-stroked-button class="btn-desclassificar" (click)="iniciarDecisao('desclassificar')">
      <mat-icon>cancel</mat-icon> Desclassificar
    </button>
  </div>
  <div class="reporte-confirmacao" *ngIf="mostrarConfirmacaoDecisao">
    <p *ngIf="mostrarConfirmacaoDecisao === 'liberar'">Ao liberar, a prova seguirá na avaliação normalmente.</p>
    <p *ngIf="mostrarConfirmacaoDecisao === 'desclassificar'">Ao desclassificar, o candidato será marcado como NÃO HABILITADO.<br>Esta ação <strong>não</strong> pode ser desfeita.</p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Justificativa</mat-label>
      <textarea matInput [(ngModel)]="justificativaDecisao" rows="2" style="resize: none;"
        placeholder="Informe a justificativa para sua decisão..."></textarea>
    </mat-form-field>
    <div class="confirmacao-btns">
      <button mat-stroked-button (click)="cancelarDecisao()">Cancelar</button>
      <button *ngIf="mostrarConfirmacaoDecisao === 'liberar'" mat-stroked-button class="btn-liberar"
        [disabled]="!justificativaDecisao.trim()" (click)="confirmarDecisao()">
        Liberar para Correção
      </button>
      <button *ngIf="mostrarConfirmacaoDecisao === 'desclassificar'" mat-stroked-button class="btn-desclassificar"
        [disabled]="!justificativaDecisao.trim()" (click)="confirmarDecisao()">
        Confirmar Desclassificação
      </button>
    </div>
  </div>
</div>
